import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSingleLogQuery } from "../../Slices/roomNateApis";
import { Button, Stack, Typography, useMediaQuery } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import FabricLayouts from "../RoomGeneratorLayout/fabricLayouts";
import {
  RenderCustomNextArrow,
  RenderCustomPrevArrow,
} from "../../utils/functions";

const SingleLog = () => {
  const { id } = useParams();
  const isDesktop = useMediaQuery("(min-width:750px)");
  const [activeLayout, setactiveLayout] = useState(0);
  const handleCarouselChange = (index) => {
    setactiveLayout(index);
  };

  const navigate = useNavigate();
  const { data, isLoading } = useSingleLogQuery({ logId: id });

  const handlePrevClick = () => {
    if (activeLayout > 0) {
      setactiveLayout(activeLayout - 1);
    }
  };

  const handleNextClick = () => {
    if (activeLayout < data?.response?.body?.result?.length - 1) {
      setactiveLayout(activeLayout + 1);
    }
  };

  return (
    <>
      {!isLoading ? (
        <>
          <Carousel
            selectedItem={activeLayout}
            className="threeDCarousel"
            onChange={handleCarouselChange}
            swipeable={true}
            showStatus={false}
            showArrows={false}
            showIndicators={false}
          >
            {data?.response?.body?.result?.length >= 1 &&
              data?.response?.body?.result?.map((_d, idx) => {
                return (
                  <div key={idx}>
                    <FabricLayouts
                      activeLayout={activeLayout}
                      layoutData={_d}
                      vertices={data?.request?.vertices}
                      windows={data?.request?.windows}
                      firePlaces={data?.request?.firePlaces}
                      doors={data?.request?.doors}
                      admin={true}
                    />
                  </div>
                );
              })}
          </Carousel>

          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={{
              width: { xs: "100%", md: "50%" },
              mx: "auto",
              marginTop: isDesktop ? "-70px" : "-102px",
            }}
          >
            <Stack
              flexDirection={"row"}
              width={"70%"}
              sx={{
                backgroundColor: "white",
                borderRadius: "25px",
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 4px",
              }}
              justifyContent={"space-around"}
              alignItems={"center"}
            >
              <RenderCustomPrevArrow onClickHandler={handlePrevClick} />
              <Typography fontWeight={"bold"}>
                Plan {activeLayout + 1} of{" "}
                {data?.response?.body?.result?.length}
              </Typography>
              <RenderCustomNextArrow onClickHandler={handleNextClick} />
            </Stack>
          </Stack>

          <Stack alignItems={"center"}>
            <Button
              variant="outlined"
              className="padding-button"
              sx={{
                width: { xs: "100%", md: "50%" },
                mx: "auto",
                mt: 4,
              }}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Stack>
        </>
      ) : (
        <>
          <Typography textAlign={"center"} mt={3} fontSize={13}>
            Loading..
          </Typography>
        </>
      )}
    </>
  );
};

export default SingleLog;
